module.exports = __webpack_public_path__ + "img/Marie_Claire_Magazine_logo.d6345d9a.svg";